import React from "react";
import Navstyle from "./Navstyle.css";
import ReactDOM from 'react-dom';

const headerStyle = {
    position: 'sticky',
    top: 0,
    textDecoration: 'none',
};


const Navbar = props =>(
    
    <header style={headerStyle}>
    <div className="font-face-gm">
      <nav id="navsty">
        <a style = {{textDecoration: 'none'}} href="#">🔮</a>
        <a style = {{color: '#FFF', textDecoration: 'none'}} id= "abouttitle" href="#">
          About me!
        </a>

        <a style = {{color: '#FFF', textDecoration: 'none'}} href="#skills">
          Skills
        </a>

        <a style = {{color: '#FFF', textDecoration: 'none'}} href="#contact">
          Contact Me
        </a>

        <a style = {{color: '#FFF', textDecoration: 'none'}} href="#projects">
          Projects
        </a>
        </nav>
    </div>
    </header>
)

export default Navbar;

